export default __webpack_public_path__ + "static/media/undereyeDarkness.4440c011.svg";